import { LogOut, User } from "lucide-react"
import { useState } from "react"
import { useAuth } from "react-oidc-context"

export const UserRoleLabes : {[key:string]: string} = {
    "CANSO_ADMIN": "Canso Admin",
    "ADMIN": "Admin",
    "INVESTIGATOR": "Investigator",
    "VIEWER": "Viewer",
    "COLLABORATOR": "Collaborator",
    "CASE_INITIATOR": "Case Initiator",
    "SUPERVISING_AUTH_L2": "FRMD",
    "AUDITOR": "Auditor",
    "BUSINESS_ADMIN": "Business Admin",
    "PLATFORM_ADMIN": "Platform Admin",
    "SUPERVISING_AUTH_L1": "Zonal Authority"
}

const UserProfileCard: React.FC = () => {

    const auth = useAuth();

    const [isOpen, setIsOpen] = useState(false)

    return (
        auth.user?
            <div className="relative">
                <button 
                    className="flex items-center justify-between p-3 rounded-md hover:bg-neutral-100 text-neutral-600"
                    onClick={() => {setIsOpen(current => !current)}}
                >
                    <div className="flex items-center">
                        <div className="h-8 w-8 rounded-full bg-indigo-600 flex items-center justify-center text-white">
                            <User className="h-5 w-5"/>
                        </div>
                        <div className="ml-3">
                            <p className="text-sm font-medium">{auth.user.profile.name}</p>
                            <p className="text-xs text-neutral-500">{UserRoleLabes[(auth.user.profile.realm_access as any)?.roles[0] as string]}</p>
                        </div>
                    </div>
                </button>
                {isOpen && 
                    <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-md shadow-lg border border-neutral-200 py-1 z-30">
                        <button 
                            className="w-full text-left px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-100 flex items-center"
                            onClick={() => {auth.signoutRedirect()}}
                        >
                            <LogOut className="h-4 w-4 mr-2" />
                            Logout
                        </button>
                    </div>
                }
            </div>
        : <></>
    )
}

export default UserProfileCard;